class AppHeaders
{
    getHeaders = (token) =>
    {
        return new Headers({
            'Authorization'               : 'Bearer ' + token,
            'Content-Type'                : 'text/plain'
        });
    }
}

export default AppHeaders



// WEBPACK FOOTER //
// ./src/classes/Headers.js